import React from "react";
import "./Preloader.css";

const Preloader = (props) => {
  return (
    <div className="Preload_body" id={props.id}>
      <div id="P_ring3">
        <div id="P_ring2">
          <div id="P_ring1">
            <div id="P">P</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Preloader;
